import React from 'react';

export function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-gray-800">
      <div className="max-w-lg mx-auto px-4 flex items-center justify-center">
        <div className="flex items-center gap-2">
          {/* Logo */}
          <img
              src="/galleryg-logo.webp"
              alt="gallery g logo"
              className="h-14"
            />
        </div>
      </div>
    </nav>
  );
}
